/** Static configuration for the EOS Assistant chat. */

export interface AssistantSuggestion {
  /** Short label shown on the suggestion card. */
  label: string;
  /** Prompt sent when the card is picked. */
  prompt: string;
}

/** Starter prompts shown in the empty state — each maps to a real tool path. */
export const ASSISTANT_SUGGESTIONS: AssistantSuggestion[] = [
  { label: 'Artikel suchen', prompt: 'Suche im Katalog nach iPhone.' },
  {
    label: 'Lagerbestand prüfen',
    prompt: 'Welche Apple-Artikel sind aktuell auf Lager?',
  },
  {
    label: 'Geschäftspartner finden',
    prompt: 'Finde Geschäftspartner mit „GmbH“ im Namen.',
  },
  {
    label: 'Bestellungen ansehen',
    prompt: 'Zeig mir die letzten Bestellungen eines Geschäftspartners.',
  },
  {
    label: 'E-Mail entwerfen',
    prompt:
      'Hilf mir, eine E-Mail an einen Geschäftspartner zu entwerfen — es geht ' +
      'um eine verspätete Lieferung. Schlag mir verschiedene Ansätze vor.',
  },
];
